import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  constructor(private http:HttpClient) { }

  getCourseList(resource:any){
    return this.http.post<any[]>(`${ConfigService.toApiUrl("generate-courses-pdf")}`,resource,ConfigService.addAction('list'));
  }
  
  getProfessorList(resource:any){
    return this.http.post<any[]>(`${ConfigService.toApiUrl("generate-professors-pdf")}`,resource,ConfigService.addAction('list'));
  }
  
  getProfessorClassroomsList(resource:any){
    return this.http.post<any[]>(`${ConfigService.toApiUrl("generate-professor-classrooms-pdf")}`,resource,ConfigService.addAction('list'));
  }

  getProfessorCoursesList(resource:any){
    return this.http.post<any[]>(`${ConfigService.toApiUrl("generate-professor-courses-pdf")}`,resource,ConfigService.addAction('list'));
  }

  getClassroomStudentsList(resource:any){
    return this.http.post<any[]>(`${ConfigService.toApiUrl("generate-classroom-students-pdf")}`,resource,ConfigService.addAction('list'));
  }

  getGeneralStudentNoteBook(resource:any){
    return this.http.post<any[]>(`${ConfigService.toApiUrl("generate-note-book-all-students-pdf")}`,resource,ConfigService.addAction('list'));
  }
  
  getStudentNoteBook(resource:any){
    return this.http.post<any[]>(`${ConfigService.toApiUrl("generate-note-book-students-pdf")}`,resource,ConfigService.addAction('list'));
  }
  
  getNoteBookProfessor(resource:any){
    return this.http.post<any[]>(`${ConfigService.toApiUrl("generate-note-book-professor-pdf")}`,resource,ConfigService.addAction('list'));
  }
  
}
